/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ carrierMessage: NonNullable<unknown> }} Carrier_Form_RejectedInputs */

const vi_carrier_form_rejected = /** @type {(inputs: Carrier_Form_RejectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Viettel Post từ chối yêu cầu: ${i?.carrierMessage}`)
};

/**

* @param {Carrier_Form_RejectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_rejected = /** @type {((inputs: Carrier_Form_RejectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_RejectedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_rejected(inputs)
});